module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGMoTw//TwlmGDVg1IBRA4aLAQAjJzQfRxlw2QAAAABJRU5ErkJggg=="